import type { ApolloClient } from "@apollo/client";
import type { Dispatch } from "redux";

import { transactionConstants } from "./types";
import {
  getAllTransactions,
  cancelTransaction,
} from "services/transactionService";
import ActionCreator from "utils/actionHandler";

export const getTransactions = (
  client: ApolloClient<object>,
  accountId: string
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof getAllTransactions>>
    >(transactionConstants.GET_TRANSACTIONS);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      getAllTransactions(client, accountId)
    );
  };
};

export const cancelPendingTransaction = (
  client: ApolloClient<object>,
  accountId: string,
  transactionId: string
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof cancelTransaction>>
    >(transactionConstants.CANCEL_TRANSACTION);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      cancelTransaction(client, accountId, transactionId),
      transactionId
    );
  };
};
